module.exports = __webpack_public_path__ + "img/dlqf-on.a067b454.svg";